import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import { i18n } from './i18n';
import { baseComponents } from "@dutypay/front-end-design-system";
import { name, version } from '../package.json';

const pinia = createPinia()
const app = createApp(App);

app.use(router)
  .use(pinia)
  .use(i18n)

Object.entries(baseComponents).forEach(([name, component]) => {
  app.component(name, component);
});
app.mount("#app");

console.log(name + " version: ", version)



